import React from 'react';
import { Box, Text, Heading, Image, VStack } from '@chakra-ui/react';

const TextSlide = ({ backgroundImage, galleryText }) => {
  // Estrai l'URL dell'immagine di sfondo
  let backgroundImageUrl = null;

  if (backgroundImage) {
    backgroundImageUrl =
      typeof backgroundImage === 'string'
        ? backgroundImage
        : backgroundImage.url || null;
  }

  // Mappa il colore del testo: Light -> #FFFDEF, Dark -> #45505A, default -> #45505A
  const getTextColor = (textColor) => {
    if (!textColor) return '#45505A'; // Default dark
    if (textColor.toLowerCase() === 'light') return '#FFFDEF';
    if (textColor.toLowerCase() === 'dark') return '#45505A';
    // Se è già un codice colore, usalo direttamente
    return textColor;
  };

  // Estrai il testo dal JSON galleryText
  // galleryText può essere:
  // - Una stringa semplice
  // - Un oggetto JSON con { "title": "...", "subtitle": "...", "textColor": "Light/Dark" }
  // - Un oggetto JSON con { "text": "...", "textColor": "Light/Dark" }
  let titleText = '';
  let subtitleText = '';
  let simpleText = '';
  let textColor = null;

  if (galleryText) {
    if (typeof galleryText === 'string') {
      try {
        // Prova a parsare se è una stringa JSON
        const parsed = JSON.parse(galleryText);
        if (typeof parsed === 'string') {
          simpleText = parsed;
        } else if (parsed.title || parsed.subtitle) {
          titleText = parsed.title || '';
          subtitleText = parsed.subtitle || '';
          textColor = parsed.textColor || null;
        } else {
          simpleText = parsed.text || parsed.content || JSON.stringify(parsed);
          textColor = parsed.textColor || null;
        }
      } catch {
        // Se non è JSON valido, usa direttamente come stringa
        simpleText = galleryText;
      }
    } else if (typeof galleryText === 'object') {
      // Se è già un oggetto
      if (galleryText.title || galleryText.subtitle) {
        titleText = galleryText.title || '';
        subtitleText = galleryText.subtitle || '';
        textColor = galleryText.textColor || null;
      } else {
        simpleText =
          galleryText.text ||
          galleryText.content ||
          JSON.stringify(galleryText);
        textColor = galleryText.textColor || null;
      }
    }
  }

  const textColorValue = getTextColor(textColor);

  return (
    <Box
      height="100vh"
      width="100vw"
      bg="black"
      position="relative"
      overflow="hidden"
    >
      {/* Immagine di sfondo ruotata */}
      {backgroundImageUrl && (
        <Image
          src={backgroundImageUrl}
          alt="Background"
          position="absolute"
          top="50%"
          left="50%"
          width="100vh"
          height="100vw"
          objectFit="cover"
          opacity={1}
          zIndex={0}
          transform="translate(-50%, -50%) rotate(-90deg)"
          transformOrigin="center"
          onError={(e) => {
            console.error('Errore caricamento sfondo TextSlide:', e);
            console.log('backgroundImageUrl:', backgroundImageUrl);
          }}
        />
      )}

      {/* Contenuto ruotato */}
      <Box
        position="absolute"
        top={0}
        left={0}
        width="100%"
        height="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        p={8}
        transform="rotate(-90deg)"
        transformOrigin="center"
        zIndex={2}
      >
        {/* Container con proporzioni 9:16 per schermo verticale */}
        <Box
          width="90vh"
          height="calc(90vh * 16 / 9)"
          maxWidth="90vw"
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          px={4}
        >
          {/* Testo centrato */}
          {(titleText || subtitleText || simpleText || galleryText) && (
            <Box textAlign="center" zIndex={3} maxWidth="80%">
              <VStack spacing={4}>
                {/* Titolo grande (se presente) */}
                {titleText && (
                  <Heading
                    fontSize="6xl"
                    color={textColorValue}
                    fontWeight="900"
                    whiteSpace="pre-wrap"
                    wordBreak="break-word"
                    lineHeight="1.2"
                  >
                    {titleText}
                  </Heading>
                )}

                {/* Sottotitolo piccolo (se presente) */}
                {subtitleText && (
                  <Text
                    fontSize="2xl"
                    color={textColorValue}
                    fontWeight="normal"
                    whiteSpace="pre-wrap"
                    wordBreak="break-word"
                    mt={titleText ? 2 : 0}
                  >
                    {subtitleText}
                  </Text>
                )}

                {/* Testo semplice (se non ci sono title/subtitle) */}
                {simpleText && !titleText && !subtitleText && (
                  <Text
                    fontSize="4xl"
                    color={textColorValue}
                    fontWeight="bold"
                    whiteSpace="pre-wrap"
                    wordBreak="break-word"
                  >
                    {simpleText}
                  </Text>
                )}

                {/* Fallback: mostra galleryText raw se non è stato parsato */}
                {!titleText && !subtitleText && !simpleText && galleryText && (
                  <Text
                    fontSize="4xl"
                    color={textColorValue}
                    fontWeight="bold"
                    whiteSpace="pre-wrap"
                    wordBreak="break-word"
                  >
                    {typeof galleryText === 'string'
                      ? galleryText
                      : JSON.stringify(galleryText)}
                  </Text>
                )}
              </VStack>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default TextSlide;
